import { LineVariant } from './line_variant';
import { Departure } from './departure';

export class TempDeps {
    line_name: string;
    direction: string;
    deps: Departure[];
}